import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  nominalStyles: { alignItems: 'center', flexDirection: 'row' },
});
export default styles;
